import styles from './avatar.module.scss';
import {EditableProfileImage} from '../../pages/profile/components/profile_image.tsx';
import {Size} from '../../enums/size.ts';
import {classNames} from '../../support/classnames.ts';

interface OwnProps {
    name: string;
    editable?: boolean;
    size?: Size;
    imageSize?: string | 'full | half';
    src?: string | null;
    onClick?: () => void;
    darkBackground?: boolean;
}

export function Avatar({
    name,
    editable = false,
    size = Size.Large,
    imageSize = 'full',
    src,
    onClick,
    darkBackground = false,
}: OwnProps) {
    return (
        <div
            className={classNames(styles.avatar, {
                [styles.large]: size === Size.Large,
                [styles.medium]: size === Size.Medium,
                [styles.small]: size === Size.Small,
            })}
            onClick={onClick}
        >
            {editable ? (
                <div className={styles.avatar__image}>
                    <EditableProfileImage profilePictureUrl={src ?? null} name={name} />
                </div>
            ) : src ? (
                <div
                    className={classNames(styles.avatar__image, {
                        [styles.half]: imageSize === 'half',
                        [styles.dark_background]: darkBackground,
                    })}
                >
                    <img src={src} alt={name ?? 'Image'} onError={(e) => (e.currentTarget.style.display = 'none')} />
                </div>
            ) : (
                <div className={styles.avatar__initials}>
                    <span>{name.substring(0, 1)}</span>
                </div>
            )}

            {size === Size.Large && (
                <div className={styles.avatar__name}>
                    <h2>{name}</h2>
                </div>
            )}
        </div>
    );
}
